import FeedbackPage from '@app-studio-web/ui/pages/FeedbackPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'
import useUpdateMode from '../../hooks/useUpdateMode'
import { saveAnswer } from '../../utils/onboardingStorage'

const QUESTION_KEY = 'transformation_feedback'

export default function TransformationFeedbackPage() {
  const submit = useSubmit()
  const { isUpdate, postToReactNative } = useUpdateMode()
  const { t } = useTranslation()

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const answer = {
      question_key: QUESTION_KEY,
      question: 'Transformation feedback shown',
      answer_key: 'acknowledged',
      answer: 'acknowledged',
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(event.currentTarget, { method: 'post' })
    }
  }

  return (
    <FeedbackPage
      emoji="🦋"
      heading={t('pages.onboarding.transformationFeedback.heading')}
      text={t('pages.onboarding.transformationFeedback.text')}
      onSubmit={onSubmit}
    />
  )
}
